import React, { useEffect, useState } from 'react';
import classes from "./WordGameOver.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import { resetIndex } from '../store/slices/wordGameSlice/activeTileSlice';
import { resetTiles } from '../store/slices/wordGameSlice/tileWordSlice';
import { resetEnteredWords } from '../store/slices/wordGameSlice/enteredWordSlice';
import { resetTargetWord } from '../store/slices/wordGameSlice/targetWordSlice';
import { resetTargetWord3 } from '../store/slices/wordGameSlice/targetWord3Slice';
import { resetWord3Result } from '../store/slices/wordGameSlice/word3Result';
import { resetWordResult } from '../store/slices/wordGameSlice/wordResult';
import { ResetTime, ResetTimeForProgress } from '../store/slices/wordGameSlice/wordTimeSlice';

const WordGameOver = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [userProfile, setUserProfile] = useState(null);

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (!location?.state?.result) {
            navigate("/home");
        }
    }, [location?.state]);

    /* PREVENT THE USER FROM CLICKING BACK BUTTON OF BROWSER... */
    useEffect(() => {
        window.history.pushState(null, null, document.URL);
        window.addEventListener("popstate", function () {
            window.history.pushState(null, null, document.URL);
        });
    }, [window]);

    return (
        <>
            <div className={classes.container}>
                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/home");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>Game Result</h2>
                </div>

                {location?.state?.result == "win" ? (<>
                    <div className={classes.modal_img_container}>
                        <img
                            className={classes.modal_img}
                            src="/assets/images/happy.png"
                            alt="result"
                        />
                    </div>
                    <div className={classes.modal_description}>
                        <h1>Congratulations...</h1>
                        <p>You guessed right!</p>
                        <p>The word was {location?.state?.word}</p>
                    </div>
                </>) : (<>
                    <div className={classes.modal_img_container}>
                        <img
                            className={classes.modal_img}
                            src="/assets/images/game_over.png"
                            alt="result"
                        />
                    </div>
                    <div className={classes.modal_description}>
                        <h1>OOPS...</h1>
                        <p>You guessed wrong!</p>
                        <p>The word was {location?.state?.word}</p>
                    </div>
                </>)}


                {/* <div className={classes.points_container_center}>

                    <div className={classes.user_points_container}>
                        <div className={classes.rewards_animation}>
                            <Lottie animationData={RewardsAnimation} loop autoPlay className={classes.animation_reward} />
                        </div>
                        <p className={classes.points}>{userProfile?.total_points} {t("2")}</p>
                    </div>
                </div> */}

                <div className={classes.buttons_container}>
                    <button
                        type="button"
                        className={classes.play_btn}
                        // onClick={closeModalHandler}
                        onClick={() => {
                            dispatch(resetIndex());
                            dispatch(resetTiles());
                            dispatch(resetEnteredWords());
                            dispatch(resetTargetWord());
                            dispatch(resetTargetWord3());
                            dispatch(resetWord3Result());
                            dispatch(resetWordResult());
                            dispatch(ResetTime());
                            dispatch(ResetTimeForProgress());

                            navigate("/word-game", {
                                state: {
                                    level: location?.state?.level
                                }
                            })
                        }}
                    >
                        Play Again!
                    </button>
                    <button
                        type="button"
                        className={classes.back_btn}
                        onClick={() => navigate("/")}
                    // onClick={goBack}
                    >
                        Go Back!
                    </button>
                </div>


            </div>
        </>
    )
}

export default WordGameOver;